import React, { useState } from "react"
import { useIntl } from "react-intl"
import { RangeCalendar } from "components/Shared/MultiRangeCalendar"
import MultiRangeCalendar from "components/Shared/MultiRangeCalendar/MultiRangeCalendar"
import {
	getInitialMaxDate,
	getIntialMinDate,
} from "components/Shared/PhronesisCalendar/PhronesisCalendar.utils"
import {
	PHRONESIS_DEFAULT_DATE_FORMAT,
	formatDate,
} from "../../../helpers/temporal"
import { SinglePeriod } from "components/Labs/CrossSelling/interfaces"
import {
	CUSTOM_RANGES_PRESET,
	DEFAULT_CROSS_SELLING_CALENDAR_TITLE,
	LAST_30_DAYS_PRESET,
	LAST_90_DAYS_PRESET,
	MONTH_RANGE_PRESET,
	MOVING_YEAR_RANGE_PRESET,
	QUARTER_RANGE_PRESET,
	YEAR_RANGE_PRESET,
} from "./constants"
import "./CrossSellingCalendar.styles.scss"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"

interface CrossSellingCalendarProps {
	setPeriod: (period: SinglePeriod) => void
}

const CrossSellingCalendar: React.FC<CrossSellingCalendarProps> = (props) => {
	const intialMaxDate = getInitialMaxDate()
	const intialMinDate = getIntialMinDate()
	const intl = useIntl()
	const {
		setSingleInterval,
		singleInterval,
		setSinglePreset,
		singlePreset,
	} = useFiltersContext()
	const [currentRange, setCurrentRange] = useState(singleInterval)
	const { setPeriod } = props
	const messageCalendarDays = intl.formatMessage({
		id:
			"phronesis.transactional.application.commercial.benchmark.calendar.message.days",
	})

	const handleOnChange = (rangesCalendar: RangeCalendar[]) => {
		setCurrentRange(rangesCalendar)
	}

	const handleOnSubmit = (ranges: RangeCalendar[], definedRangeId: string) => {
		const startDate = formatDate(
			ranges[0].startDate as Date,
			PHRONESIS_DEFAULT_DATE_FORMAT
		)
		const endDate = formatDate(
			ranges[0].endDate as Date,
			PHRONESIS_DEFAULT_DATE_FORMAT
		)

		setPeriod({ startDate, endDate })
		setSingleInterval(ranges)
		setSinglePreset(definedRangeId)
	}

	return (
		<MultiRangeCalendar
			onChange={handleOnChange}
			onSubmit={handleOnSubmit}
			selectedPreset={singlePreset}
			defaultTitle={DEFAULT_CROSS_SELLING_CALENDAR_TITLE}
			ranges={currentRange}
			showPresets
			monthsShown={2}
			definedRanges={[
				YEAR_RANGE_PRESET,
				MOVING_YEAR_RANGE_PRESET,
				QUARTER_RANGE_PRESET,
				MONTH_RANGE_PRESET,
				LAST_90_DAYS_PRESET,
				LAST_30_DAYS_PRESET,
				CUSTOM_RANGES_PRESET,
			]}
			locale={intl.locale}
			maxDate={intialMaxDate}
			minDate={intialMinDate}
			footerMenu={
				<div className="benchmark-calendar__menu">
					<p className="benchmark-calendar__message">{messageCalendarDays}</p>
				</div>
			}
		/>
	)
}

export default CrossSellingCalendar
